import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IBook } from 'app/shared/model/book.model';
import { getEntities as getBooks } from 'app/entities/book/book.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntity, updateEntity, createEntity, reset } from './book-subscription.reducer';
import { IBookSubscription } from 'app/shared/model/book-subscription.model';
// tslint:disable-next-line:no-unused-variable
import { convertDateTimeFromServer } from 'app/shared/util/date-utils';
import { keysToValues } from 'app/shared/util/entity-utils';

export interface IBookSubscriptionUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export interface IBookSubscriptionUpdateState {
  isNew: boolean;
  bookId: number;
  createdById: number;
  lastModifiedById: number;
  userId: number;
}

export class BookSubscriptionUpdate extends React.Component<IBookSubscriptionUpdateProps, IBookSubscriptionUpdateState> {
  constructor(props) {
    super(props);
    this.state = {
      bookId: 0,
      createdById: 0,
      lastModifiedById: 0,
      userId: 0,
      isNew: !this.props.match.params || !this.props.match.params.id
    };
  }

  componentDidMount() {
    if (this.state.isNew) {
      this.props.reset();
    } else {
      this.props.getEntity(this.props.match.params.id);
    }

    this.props.getBooks(0, 1000, 'name');
    this.props.getUsers(0, 2500, 'email');
  }

  saveEntity = (event, errors, values) => {
    values.subscriptionStartDate = new Date(values.subscriptionStartDate);
    values.subscriptionEndDate = new Date(values.subscriptionEndDate);
    values.createdDate = new Date(values.createdDate);
    values.lastModifiedDate = new Date(values.lastModifiedDate);

    if (errors.length === 0) {
      const { bookSubscriptionEntity } = this.props;
      const entity = {
        ...bookSubscriptionEntity,
        ...values
      };

      if (this.state.isNew) {
        this.props.createEntity(entity);
      } else {
        this.props.updateEntity(entity);
      }
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.history.push('/entity/book-subscription');
  };

  bookUpdate = element => {
    const name = element.target.value.toString();
    if (name === '') {
      this.setState({
        bookId: -1
      });
    } else {
      for (const i in this.props.books) {
        if (name === this.props.books[i].name.toString()) {
          this.setState({
            bookId: this.props.books[i].id
          });
        }
      }
    }
  };

  createdByUpdate = element => {
    const login = element.target.value.toString();
    if (login === '') {
      this.setState({
        createdById: -1
      });
    } else {
      for (const i in this.props.users) {
        if (login === this.props.users[i].login.toString()) {
          this.setState({
            createdById: this.props.users[i].id
          });
        }
      }
    }
  };

  lastModifiedByUpdate = element => {
    const login = element.target.value.toString();
    if (login === '') {
      this.setState({
        lastModifiedById: -1
      });
    } else {
      for (const i in this.props.users) {
        if (login === this.props.users[i].login.toString()) {
          this.setState({
            lastModifiedById: this.props.users[i].id
          });
        }
      }
    }
  };

  userUpdate = element => {
    const email = element.target.value.toString();
    if (email === '') {
      this.setState({
        userId: -1
      });
    } else {
      for (const i in this.props.users) {
        if (email === this.props.users[i].email.toString()) {
          this.setState({
            userId: this.props.users[i].id
          });
        }
      }
    }
  };

  render() {
    const isInvalid = false;
    const { bookSubscriptionEntity, books, users, loading, updating } = this.props;
    const { isNew } = this.state;

    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h2 id="webBasedManualApp.bookSubscription.home.createOrEditLabel">Create or edit a BookSubscription</h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <AvForm model={isNew ? {} : bookSubscriptionEntity} onSubmit={this.saveEntity}>
                {!isNew ? (
                  <AvGroup>
                    <Label for="id">ID</Label>
                    <AvInput id="book-subscription-id" type="text" className="form-control" name="id" required readOnly />
                  </AvGroup>
                ) : null}
                <AvGroup>
                  <Label id="isActiveLabel" check>
                    <AvInput
                      id="book-subscription-isActive"
                      type="checkbox"
                      className="form-control"
                      name="isActive"
                      value={isNew ? true : this.props.bookSubscriptionEntity.isActive}
                    />
                    Is Active
                  </Label>
                </AvGroup>
                <AvGroup>
                  <Label id="subscriptionStartDateLabel" for="subscriptionStartDate">
                    Subscription Start Date
                  </Label>
                  <AvInput
                    id="book-subscription-subscriptionStartDate"
                    type="datetime-local"
                    className="form-control"
                    name="subscriptionStartDate"
                    value={
                      isNew
                        ? convertDateTimeFromServer(new Date())
                        : convertDateTimeFromServer(this.props.bookSubscriptionEntity.subscriptionStartDate)
                    }
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="subscriptionEndDateLabel" for="subscriptionEndDate">
                    Subscription End Date
                  </Label>
                  <AvInput
                    id="book-subscription-subscriptionEndDate"
                    type="datetime-local"
                    className="form-control"
                    name="subscriptionEndDate"
                    value={isNew ? null : convertDateTimeFromServer(this.props.bookSubscriptionEntity.subscriptionEndDate)}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="createdDateLabel" for="createdDate">
                    Created Date
                  </Label>
                  <AvInput
                    id="book-subscription-createdDate"
                    type="datetime-local"
                    className="form-control"
                    name="createdDate"
                    value={
                      isNew
                        ? convertDateTimeFromServer(new Date())
                        : convertDateTimeFromServer(this.props.bookSubscriptionEntity.createdDate)
                    }
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="lastModifiedDateLabel" for="lastModifiedDate">
                    Last Modified Date
                  </Label>
                  <AvInput
                    id="book-subscription-lastModifiedDate"
                    type="datetime-local"
                    className="form-control"
                    name="lastModifiedDate"
                    value={
                      isNew
                        ? convertDateTimeFromServer(new Date())
                        : convertDateTimeFromServer(this.props.bookSubscriptionEntity.lastModifiedDate)
                    }
                  />
                </AvGroup>
                <AvGroup>
                  <Label for="book.name">Book</Label>
                  <AvInput id="book-subscription-book" type="select" className="form-control" name="book.name" onChange={this.bookUpdate}>
                    <option value="" key="0" />
                    {books
                      ? books.map(otherEntity => (
                          <option value={otherEntity.name} key={otherEntity.id}>
                            {otherEntity.name}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="book-subscription-book" type="hidden" name="book.id" value={this.state.bookId} />
                </AvGroup>
                <AvGroup>
                  <Label for="createdBy.login">Created By</Label>
                  <AvInput
                    id="book-subscription-createdBy"
                    type="select"
                    className="form-control"
                    name="createdBy.login"
                    onChange={this.createdByUpdate}
                  >
                    <option value="" key="0" />
                    {users
                      ? users.filter(userEntity => userEntity.login === 'stevedav' || userEntity.login === 'michael').map(otherEntity => (
                          <option value={otherEntity.login} key={otherEntity.id}>
                            {otherEntity.login}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="book-subscription-createdBy" type="hidden" name="createdBy.id" value={this.state.createdById} />
                </AvGroup>
                <AvGroup>
                  <Label for="lastModifiedBy.login">Last Modified By</Label>
                  <AvInput
                    id="book-subscription-lastModifiedBy"
                    type="select"
                    className="form-control"
                    name="lastModifiedBy.login"
                    onChange={this.lastModifiedByUpdate}
                  >
                    <option value="" key="0" />
                    {users
                      ? users.filter(userEntity => userEntity.login === 'stevedav' || userEntity.login === 'michael').map(otherEntity => (
                          <option value={otherEntity.login} key={otherEntity.id}>
                            {otherEntity.login}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput
                    id="book-subscription-lastModifiedBy"
                    type="hidden"
                    name="lastModifiedBy.id"
                    value={this.state.lastModifiedById}
                  />
                </AvGroup>
                <AvGroup>
                  <Label for="user.email">User</Label>
                  <AvInput id="book-subscription-user" type="select" className="form-control" name="user.email" onChange={this.userUpdate}>
                    <option value="" key="0" />
                    {users
                      ? users.map(otherEntity => (
                          <option value={otherEntity.email} key={otherEntity.id}>
                            {otherEntity.email}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="book-subscription-user" type="hidden" name="user.id" value={this.state.userId} />
                </AvGroup>
                <Button tag={Link} id="cancel-save" to="/entity/book-subscription" replace color="info">
                  <FontAwesomeIcon icon="arrow-left" />&nbsp;
                  <span className="d-none d-md-inline">Back</span>
                </Button>
                &nbsp;
                <Button color="primary" id="save-entity" type="submit" disabled={isInvalid || updating}>
                  <FontAwesomeIcon icon="save" />&nbsp; Save
                </Button>
              </AvForm>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  books: storeState.book.entities,
  users: storeState.userManagement.users,
  bookSubscriptionEntity: storeState.bookSubscription.entity,
  loading: storeState.bookSubscription.loading,
  updating: storeState.bookSubscription.updating
});

const mapDispatchToProps = {
  getBooks,
  getUsers,
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(BookSubscriptionUpdate);
